import { tabletQuery } from '@globals/themes/themeConstants'
import Stack, { StackProps } from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ReactNode } from 'react'

type FormActionTrayProps = StackProps & {
  children: ReactNode | ReactNode[]
  mt?: number
}

const FormActionTray: React.FC<FormActionTrayProps> = ({ children, mt = 3, ...restProps }) => {
  const isTablet = useMediaQuery(tabletQuery)

  return (
    <Stack
      direction={isTablet ? 'column-reverse' : 'row'}
      justifyContent="flex-end"
      spacing={2}
      mt={mt}
      {...restProps}>
      {children}
    </Stack>
  )
}

export default FormActionTray
